import { Shuffle } from "lucide-react";
import { useFormContext } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { CreateBreakoutSessionsFormData } from "../types/create-breakout-sessions.schema";

export function RandomiseBreakoutSessionElement() {
  const form = useFormContext<CreateBreakoutSessionsFormData>();

  const participants = useVidyoStore(
    (state) => state.participants.participants,
  );

  const shuffledParticipants = [...participants]
    //we dont want to put the current user in a breakout session
    .filter((participant) => !participant.isCurrentUser)
    .sort(() => Math.random() - 0.5);

  const handleRandomiseParticipants = () => {
    const breakoutSessions = form.getValues("breakoutSessions");

    // Calculate base number of participants per session and remainder
    const totalParticipants = shuffledParticipants.length;
    const numSessions = breakoutSessions.length;
    const baseParticipantsPerSession = Math.floor(
      totalParticipants / numSessions,
    );
    const remainingParticipants = totalParticipants % numSessions;

    // Distribute participants across sessions
    const distributedSessions = breakoutSessions.map((session, index) => {
      // Calculate how many participants this session should get
      const extraParticipant = index < remainingParticipants ? 1 : 0;
      const participantsForThisSession =
        baseParticipantsPerSession + extraParticipant;

      // Get the participants for this session
      const sessionParticipants = shuffledParticipants.splice(
        0,
        participantsForThisSession,
      );

      const participants = sessionParticipants.map((participant) => ({
        name: participant.name,
        participantId: participant.participantId,
        entityId: participant.entityId,
        isAudioEnabled: participant.isAudioEnabled,
        isVideoEnabled: participant.isVideoEnabled,
        isHandRaised: false as const,
      }));

      return {
        ...session,
        participants,
      };
    });

    form.setValue("breakoutSessions", distributedSessions);
  };

  return (
    <div className="flex flex-col items-center">
      <Label className="mb-1.5">Shuffle</Label>
      <Button
        variant="ghost"
        size="icon"
        className="size-10"
        onClick={handleRandomiseParticipants}
        type="button"
        disabled={
          form.getValues("breakoutSessions").length < 2 ||
          shuffledParticipants.length < 2
        }
      >
        <Shuffle />
      </Button>
    </div>
  );
}
